import { Controller } from "@hotwired/stimulus"

import RecaptchaController from "./recaptcha_controller"

import { Elm } from "@/components/elm/Newsletter.elm"
import { logDecodingError } from "@/helpers/airbrake"
import { type GA4Event, pushGa4Event } from "@/helpers/ga4_helper"

type NewsletterPorts = {
  flagDecodingError: PortFromElm<void>
  pushGa4Event: PortFromElm<GA4Event>
  requestRecaptcha: PortFromElm<void>
  recaptchaTokenReceived: PortToElm<string>
  recaptchaExpired: PortToElm<null>
}

export default class NewsletterController extends Controller<HTMLDivElement> {
  static outlets = ["recaptcha"]
  declare readonly recaptchaOutlet: RecaptchaController

  static targets = ["container"]
  declare readonly containerTarget: HTMLElement

  static values = { elmFlags: Object }
  declare readonly elmFlagsValue: Record<string, unknown>

  private app?: ElmApp<NewsletterPorts>

  connect(): void {
    this.app = Elm.Newsletter.init({
      node: this.containerTarget,
      flags: this.elmFlagsValue
    }) as ElmApp<NewsletterPorts>

    this.app.ports.flagDecodingError.subscribe(this.logFlagsError)
    this.app.ports.pushGa4Event.subscribe(pushGa4Event)
    this.app.ports.requestRecaptcha.subscribe(this.executeRecaptcha)
  }

  disconnect(): void {
    this.app?.ports.flagDecodingError.unsubscribe(this.logFlagsError)
    this.app?.ports.pushGa4Event.unsubscribe(pushGa4Event)
    this.app?.ports.requestRecaptcha.unsubscribe(this.executeRecaptcha)
  }

  handleRecaptchaExpired(): void {
    this.app?.ports.recaptchaExpired.send(null)
  }

  handleRecaptchaTokenReceived({ detail: { token } }: CustomEvent<{ token: string }>): void {
    this.app?.ports.recaptchaTokenReceived.send(token)
  }

  private executeRecaptcha = (): void => {
    this.recaptchaOutlet.execute()
  }

  private logFlagsError = (): void => {
    logDecodingError(this.elmFlagsValue as Flags)
  }
}
